import { Node } from "@xyflow/react";

import { ZapNodeData } from "../types";

export function filterByZapNodes(nodes: Node[]): Node<ZapNodeData>[] {
  return nodes.filter((node) => node.type === "zap") as Node<ZapNodeData>[];
}
